/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Else, If, Then } from "react-if";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Box, FlexContainer, Text, theme } from "@nordcloud/gnui";

const InfoBox = styled.div<{ color: string }>`
  display: block;
  background: ${(props) => props.color};
  width: 4rem;
  text-align: center;
  height: 1.5rem;
  color: ${theme.color.background.ui01};
  font-size: 0.75rem;
  border-radius: 0.1rem;
  margin-right: 0.5rem;
  clear: both;
`;

const StyledLink = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

type HomepageLink = {
  label: string;
  url: string;
  // " " - fallback used to display empty block next to label
  count?: number | " ";
  danger?: boolean;
};

type Props = {
  links: HomepageLink[];
  heading: string;
};

export function HomepageColumn({ links, heading }: Props) {
  return (
    <Box minHeight="100%">
      <FlexContainer justifyContent="space-between">
        <Text isTitle tag="header" weight="medium" mb={theme.spacing.spacing04}>
          {heading}
        </Text>
      </FlexContainer>

      <FlexContainer justifyContent="flex-start" alignItems="flex-start">
        <div>
          <ul>
            {links
              .filter(({ count }) => count != null && count !== 0)
              .map(({ label, url, count, danger }) => {
                return (
                  <StyledLink key={label + url + count}>
                    <If condition={Boolean(count)}>
                      <Then>
                        <InfoBox
                          color={
                            danger
                              ? theme.color.background.error
                              : theme.color.background.info
                          }
                        >
                          {count}
                        </InfoBox>
                      </Then>
                      <Else>
                        <InfoBox color="transparent" />
                      </Else>
                    </If>
                    <Link
                      to={url}
                      style={{
                        color: danger
                          ? theme.color.text.error
                          : theme.color.interactive.link,
                      }}
                    >
                      {label}
                    </Link>
                  </StyledLink>
                );
              })}
          </ul>
        </div>
      </FlexContainer>
    </Box>
  );
}
